export const getBasePathName = (filename: string) => {
    let base: string = filename || '';
    const separator: string = base.includes('/') ? '/' : '\\';

    base = base.substring(base.lastIndexOf(separator) + 1);

    if (base.lastIndexOf('.') !== -1) {
        base = base.substring(0, base.lastIndexOf('.'));
    }

    return base;
};
